// Un-collapses content and hides "Show More"/"Show Less" links if the window is wider than
// the desired breakpoint, or does the opposite if the window is narrower.
// Should be called at page load and whenever the page crosses the breakpoint.
export function updateElements(contentClass, showMoreClass, showLessClass, widerThanBreakpoint) {
  if (widerThanBreakpoint) {
    $(contentClass).removeClass('hidden');
    $(showMoreClass).addClass('hidden');
    $(showLessClass).addClass('hidden');
  } else {
    $(contentClass).addClass('hidden');
    $(showMoreClass).removeClass('hidden');
    $(showLessClass).addClass('hidden');
  }
}

// Makes "Show More"/"Show Less" links work.
export function setupCollapse(contentClass, showMoreClass, showLessClass) {
  $(showMoreClass).add(showLessClass).click(function(e) {
    e.preventDefault();
    $(this).addClass('hidden');
  });

  $(showMoreClass).click(function() {
    $(contentClass).removeClass('hidden');
    $(showLessClass).removeClass('hidden');
  });

  $(showLessClass).click(function() {
    $(contentClass).addClass('hidden');
    $(showMoreClass).removeClass('hidden');
  });
}
